import script from "./TutorialWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialWindow.vue?vue&type=script&setup=true&lang=js"

import "./TutorialWindow.vue?vue&type=style&index=0&id=b0398e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0398e2c"]])

export default __exports__